import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  malfunctions: [],
  loadingMalfunctions: false,
  malfunctionsCategories: [],
  loadingMalfunctionsCategories: false,
  vehicleNumber: null,
};

const malfunctionSlice = createSlice({
  name: "malfunction",
  initialState,
  reducers: {
    loadingMalfunctions(state) {
      state.loadingMalfunctions = true;
    },
    loadingMalfunctionsDone(state) {
      state.loadingMalfunctions = false;
    },
    loadingMalfunctionsCategories(state) {
      state.loadingMalfunctionsCategories = true;
    },
    loadingMalfunctionsCategoriesDone(state) {
      state.loadingMalfunctionsCategories = false;
    },
    setMalfunctions(state, action) {
      state.malfunctions = action.payload;
    },
    setMalfunctionsCategories(state, action) {
      state.malfunctionsCategories = action.payload;
    },
    setVehicleNumber(state, action) {
      state.vehicleNumber = action.payload;
    },
  },
});

export const {
  loadingMalfunctions,
  loadingMalfunctionsDone,
  loadingMalfunctionsCategories,
  loadingMalfunctionsCategoriesDone,
  setMalfunctions,
  setMalfunctionsCategories,
  setVehicleNumber,
} = malfunctionSlice.actions;

export default malfunctionSlice.reducer;
